import { ORGANIZATION_TYPES } from './enums';
import { validateEmail } from './validate';
import { get } from 'lodash';

export const QUERY_SEARCH_STRING = 'QuerySearchString';
export const GOOGLE_ADS_CLICK_IDENTIFIERS = 'GoogleAdsCLickIdentifiers';
export const REFERRAL_CODE_STORAGE_KEY = 'ReferralCode';

export const validGoogleAdsParams = ['gclid', 'wbraid', 'gbraid'];

export const validateQuerySearchString = (key, value) => {
  if (!value || !key) return false;

  if (key === 'defaultEventSettingId') return ORGANIZATION_TYPES.some(({ name }) => name === value);

  if (key === 'email') return validateEmail(value);

  return true;
};

export const mapQuerySearchParams = {
  companyName: 'companyName',
  organizationType: 'defaultEventSettingId',
  orgType: 'orgType',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
};

export const loadGoogleAdsFromLocalStorage = () => {
  const searchData = JSON.parse(localStorage.getItem(GOOGLE_ADS_CLICK_IDENTIFIERS));
  if (!searchData || searchData?.oauthSearchParamsSet) return {};

  const result = {};

  const params = new URLSearchParams(searchData.searchParams);
  params.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      result[key] = value;
    }
  });

  localStorage.setItem(
    GOOGLE_ADS_CLICK_IDENTIFIERS,
    JSON.stringify({
      ...searchData,
      oauthSearchParamsSet: true,
    })
  );

  return result;
};

/**
 * Get the stored referral code from localStorage
 * This is more reliable than trying to find the right RH campaign from window object
 *
 * @returns {string|null} - The referral code (mwr parameter) or null
 */
export const getReferralCode = () => {
  return localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
};

/**
 * Store the referral code (mwr parameter) in localStorage
 *
 * @param {string} code - The referral code to store
 */
export const setReferralCode = code => {
  if (code) {
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, code);
  }
};

export const verifyGoogleAdsParams = (location = {}) => {
  const searchData = JSON.parse(localStorage.getItem(GOOGLE_ADS_CLICK_IDENTIFIERS));
  const locationSearch = get(location, 'search', '');

  if (!searchData && !locationSearch) return false;

  const params = new URLSearchParams(searchData?.searchParams);
  const locationParams = new URLSearchParams(locationSearch);

  let ga = false;
  params.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      ga = true;
    }
  });

  locationParams.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      ga = true;
    }
  });

  return ga;
};
